export enum FormatType {
    THOUSAND = "K",
    MILLION = "M",
    BILLION = "B",
    GENERAL = "G"
}